import React from 'react';
import PageBanner from '@/components/site/PageBanner';
import SEO from '@/components/site/SEO';
import Reveal from '@/components/site/Reveal';
import { Target, Award, Users, Handshake, ShieldCheck, TrendingUp } from 'lucide-react';

const About = () => (
  <main>
    <SEO
      title="About Finirio | Trusted Financial Services Partner in India"
      description="Learn about Finirio — India's trusted financial services partner helping thousands of families secure home loans, LAP, business loans and personal loans from 20+ leading banks."
      path="/about-us"
      keywords="about finirio, finirio financial services, best loan advisor india"
    />
    <PageBanner title="About Us" crumbs={[ 'About Us' ]} />
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-[1240px] mx-auto px-4 lg:px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <p className="eyebrow-lux mb-3">Who we are</p>
          <h2 className="font-heading text-[30px] md:text-[38px] font-bold text-[#0b2545] tracking-tight leading-[1.15] mb-5">Empowering Your Financial Future</h2>
          <p className="text-slate-600 leading-relaxed mb-4">
            Finirio is a trusted financial services partner helping individuals and businesses across India
            achieve financial independence. From loans and investments to debt management and home search, we
            combine deep industry expertise with a customer-first approach.
          </p>
          <p className="text-slate-600 leading-relaxed">
            Our team works with a wide network of leading banks and NBFCs to bring you the most competitive
            offers, transparent processes and quick disbursals — all under one roof.
          </p>
        </Reveal>
        <div className="grid grid-cols-2 gap-5">
          {[
            { icon: Target, title: 'Our Mission', text: 'Make financial freedom accessible for every Indian household.' },
            { icon: Award, title: 'Our Vision', text: 'Be the most trusted financial services partner in India.' },
            { icon: Users, title: '10,000+ Clients', text: 'Trusted by families and businesses across the country.' },
            { icon: Handshake, title: '20+ Banks', text: 'A wide network of lending partners under one roof.' },
          ].map((c, i) => (
            <Reveal key={i} delay={i * 90}>
              <div className="card-lux p-6 h-full">
                <div className="w-11 h-11 rounded-xl grid place-items-center mb-3 border border-[#1e73be]/12" style={{ background: 'linear-gradient(160deg,#eaf3fb,#f5faff)' }}>
                  <c.icon className="w-5 h-5" style={{ color: '#1e73be' }} />
                </div>
                <h3 className="font-heading font-bold text-[#0b2545] mb-1">{c.title}</h3>
                <p className="text-sm text-slate-600">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
    <section className="py-16 md:py-20" style={{ backgroundColor: '#FBF9F4' }}>
      <div className="max-w-[1240px] mx-auto px-4 lg:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-[30px] md:text-[38px] font-bold text-[#0b2545] tracking-tight">Why choose Finirio?</h2>
          <span className="block h-[2px] w-16 mt-5 rounded-full mx-auto" style={{ background: 'linear-gradient(90deg,#c9a24b,#e8c887)' }} />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: ShieldCheck, t: 'Transparent Process', d: 'No hidden charges, clear communication at every step.' },
            { icon: TrendingUp, t: 'Best-in-Class Offers', d: 'Compare and choose from top banks for the best rates.' },
            { icon: Users, t: 'Doorstep Service', d: 'End-to-end assistance and document pickup at your doorstep.' },
          ].map((f, i) => (
            <Reveal key={i} delay={i * 110}>
              <div className="card-lux p-8 h-full">
                <div className="w-12 h-12 rounded-xl grid place-items-center mb-4 border border-[#2ea690]/15" style={{ background: 'linear-gradient(160deg,#e7f6f2,#f2fbf8)' }}>
                  <f.icon className="w-6 h-6" style={{ color: '#2ea690' }} />
                </div>
                <h3 className="font-heading font-bold text-[#0b2545] text-lg mb-2">{f.t}</h3>
                <p className="text-slate-600 text-sm leading-relaxed">{f.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  </main>
);

export default About;
